import { defineStore } from 'pinia';
import Vue from 'vue';

import { host, appointmentsClient, officialsClient } from "../api/config.js";

const CACHE_EXPIRY_TIME = 2 * 60 * 1000;

export const useVisitorAppointmentsStore = defineStore('visitorAppointmentsStore', {

    state: () => {
        return {
            appointments: [],
            officials: []
        }
    },
    actions: {
        fetchAppointments(query) {
            let action = query.action;
            delete query['action'];
            return new Promise((resolve, reject) => {
                appointmentsClient.fetchAllOfPage(query).then(res => {
                    if (!res.networkError) {
                        if (res.status == 200 && res.body && res.body.list) {
                            res.body.list.forEach(apt => {
                                if (apt.visitor) {
                                    if (apt.visitor.imageUrl == "") 
                                        apt.visitor.imageUrl = '/images/default-avatar.jpg';
                                    else
                                        apt.visitor.imageUrl = host + apt.visitor.imageUrl;
                                }
                                if (apt.official) {
                                    if (apt.official.imageUrl == "") 
                                        apt.official.imageUrl = '/images/default-avatar.jpg';
                                    else
                                        apt.official.imageUrl = host + apt.official.imageUrl;
                                }
                            });
                            if (action == 'replace')
                                this.appointments = res.body.list;
                            else
                                this.appointments = this.appointments.concat(res.body.list);
                            resolve(res);
                        } else {
                            reject();
                        }
                    } else {
                        reject();
                    }
                });
            });
            
        },
        fetchOfficials(query) {
            let action = query.action;
            delete query['action'];
            return new Promise((resolve, reject) => {
                officialsClient.fetchAllOfPage(query).then(res => {
                    if (!res.networkError) {
                        if (res.status == 200 && res.body && res.body.list) {
                            res.body.list.forEach(apt => {
                                if (apt.imageUrl) {
                                    if (apt.imageUrl == "") 
                                        apt.imageUrl = '/images/default-avatar.jpg';
                                    else
                                        apt.imageUrl = host + apt.imageUrl;
                                } else {
                                    apt.imageUrl = '/images/default-avatar.jpg';
                                }
                            });
                            if (action == 'replace')
                                this.officials = res.body.list;
                            else
                                this.officials = this.officials.concat(res.body.list);
                            resolve(res);
                        } else {
                            reject();
                        }
                    } else {
                        reject();
                    }
                });
            });
            
        },
        applyForAppointment(payload) {
            
            let appointment = {
	            officialId: payload.appointment.officialId,
	            extras: {},
	            type: payload.appointment.type,
	            topic: payload.appointment.topic,
	            requestedDate: "",
	            requestedHour: -1,
	            requestedMin: -1,
	            visitorId: payload.appointment.visitorId,
                personCount: payload.appointment.personCount
            };
            return new Promise((resolve, reject) => {
                appointmentsClient.create(appointment).then(res => {
                    if (!res.networkError) { 
                        if(res.status == 201 && res.body) {
                            
                            appointment.id = res.body.id;
                            appointment.status = 'APPLIED';
                            appointment.dateCreated = Date.now();
                            appointment.systemTime = Date.now();
                            console.log(payload.official);
                            appointment.official = payload.official;
                            // Vue.set(appointment, 'official', payload.offical);
                            Vue.set(appointment, 'visitor', payload.visitor);
                            console.log(appointment);
                            

                            
                            this.appointments = [ appointment ].concat(this.appointments);
                            // this.appointments.unshift(appointment);
                            resolve();
                        } else {
                            reject(res.status);
                        }
                    } else {
                        reject('network_error');
                    }
                });
            });
        },
        clear() {
            this.appointments = [];
            this.officials = [];
        }
    },

    
});
